import { get } from "lodash";
import { create } from "zustand";
import { toast } from "react-toastify";
import { getCustomerDataFromCaseId, saEvaluateResolution, saGetCustomerIssues, saPastResolution, saPastResponse, saSubmitBulkResponse, saSubmitIssue } from "../api";
import { createVariantIdMapForProductRead, NAV_ITEMS } from "../helper";

export const useSmartAssistStore = create((set) => ({
  isCxUsedProductBefore: true,
  setIsCxUsedProductBefore: (bool) => set({ isCxUsedProductBefore: bool }),
  currentSaPhase: NAV_ITEMS.HOME,
  setCurrentSaPhase: (phase) => set({ currentSaPhase: phase }),
  responses: {},
  setResponses: (questions) => set({ responses: questions }),
  selectedIssue: {},
  setSelectedIssue: (issue) => set({ selectedIssue: issue }),
  isSubmitDisabled: true,
  setIsSubmitDisabled: (value) => set({ isSubmitDisabled: value }),

  previousCxId: null,
  setPreviousCxId: (id) => set({ previousCxId: id }),
  resetToDefaultState: () => {
    set({ isCxUsedProductBefore: true, currentSaPhase: NAV_ITEMS.HOME, responses: {}, selectedIssue: {}, isSubmitDisabled: true, })
  },

  preReadSmartAssist: {},
  preReadSaLoading: false,
  preReadSaIsError: false,
  fetchPreReadSmartAssist: async (caseId) => {
    set({ preReadSaLoading: true });
    try {
      const response = await getCustomerDataFromCaseId(caseId);
      set({ preReadSmartAssist: response.data, });
      return response.data;
    } catch (error) {
      set({ preReadSaIsError: true });
      console.error('Error fetching Smart Assist Pre Read: ', error);
    } finally {
      set({ preReadSaLoading: false });
    }
  },

  saCustomerIssues: [],
  saVariantProductReadMap: {},
  saCustomerIssuesLoading: false,
  saCustomerIssuesIsError: false,
  fetchSmartAssistIssues: async (caseId) => {
    set({ saCustomerIssuesLoading: true });
    try {
      const response = await saGetCustomerIssues(caseId);
      const variantMap = createVariantIdMapForProductRead(response.data);
      set({ saCustomerIssues: response.data, saVariantProductReadMap: variantMap });
    } catch (error) {
      set({ saCustomerIssuesIsError: true });
      console.error('Error fetching Smart Assist Pre Read: ', error);
    } finally {
      set({ saCustomerIssuesLoading: false });
    }
  },

  saQuestionsList: {},
  saQuestionListMap: new Map(),
  saQuestionsListLoading: false,
  saQuestionsListIsError: false,
  saSubmitIssue: async (caseId, issue, engagementId) => {
    try {
      // const response = { data: DATA_QUESTIONS };
      const response = await saSubmitIssue({ caseId, issue, engagementId });
      set({ saQuestionsList: response.data, });

      // Creating MAP.
      const questionsMap = {};
      const issues = get(response, ['data', 'probing', 'issues'], []);
      const products = get(response, ['data', 'probing', 'products'], []);
      issues.forEach(question => {
        questionsMap[question.id] = { ...question, type: "issues" };
      });
      products.forEach(question => {
        questionsMap[question.id] = { ...question, type: "products" };
      });
      set({ saQuestionListMap: questionsMap, questionsMap });

      return questionsMap;
    } catch (error) {
      console.error('Error fetching Smart Assist Pre Read: ', error);
      toast.error("Error while submitting Smart Assist");
    }
  },

  saSubmitBulkResponse: async (formId, body) => {
    try {
      const response = await saSubmitBulkResponse(formId, body);
      return response.data;
    } catch (error) {
      console.error('Error fetching Smart Assist Pre Read: ', error);
      toast.error("Error while submitting Smart Assist");
    }
  },

  saEvaluatedResolution: { products: {}, issues: {} },
  resetSaEvaluatedResolution: () => set({ saEvaluatedResolution: { products: {}, issues: {} } }),
  saEvaluateResolution: async (caseId) => {
    try {
      const response = await saEvaluateResolution(caseId);
      set({ saEvaluatedResolution: response.data, });
      return response.data;
    } catch (error) {
      console.error('Error fetching Smart Assist Pre Read: ', error);
      toast.error("Error while submitting Smart Assist");
    }
  },

  saPastResolutionData: {},
  saPastResolution: async (caseId, issue) => {
    try {
      const response = await saPastResolution(caseId, issue);
      set({ saPastResolutionData: response.data, });
    } catch (error) {
      console.error('Error fetching Smart Assist Pre Read: ', error);
      toast.error("Error while submitting Smart Assist");
    }
  },

  saPastResponseData: [],
  saPastResponse: async (caseId, body) => {
    try {
      const response = await saPastResponse(caseId, body);
      set({ saPastResponseData: response.data, });
    } catch (error) {
      console.error('Error fetching Smart Assist Pre Read: ', error);
      toast.error("Error while submitting Smart Assist");
    }
  },

}));
